import React from 'react';
import {Link} from 'react-router-dom';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import {albumSelector} from '../../features/album/albumSlice';
import {getBasketQuantity} from '../../features/album/albumSlice';
import './Header.css';
import {useSelector} from 'react-redux';

function Header() {
  const {basket} = useSelector(albumSelector);

  return (
    <div className="header">
      <nav className="container header__main__navbar">
        <a href="/">
          <h2 className="header__logo">Official Bruce melody Store</h2>
        </a>

        <div className="header__nav">
          <Link to="/login" className="header__link">
            <div className="header__option">
              <span className="header__optionLineTwo">Sign In</span>
            </div>
          </Link>
          <Link to="/cart" className="header__link">
            <div className="header__optionBasket">
              <ShoppingBasketIcon />
              <span className="header__optionLineTwo header__basketCount">
                {getBasketQuantity(basket)}
              </span>
            </div>
          </Link>
        </div>
      </nav>
    </div>
  );
}

export default Header;
